module.exports = __webpack_public_path__ + "static/media/LOGO.3e1d8f4d.svg";